import React from 'react';
import { parseVideoUrl } from '../utils/videoUrl';

/**
 * Responsive 16:9 embed for YouTube / YouTube Shorts / Vimeo.
 * Renders nothing if url is missing or unrecognized.
 *
 * Props:
 *   url         — original video URL
 *   title       — accessible iframe title
 *   showSource  — if true, render a small "Video fra YouTube/Vimeo" caption
 *                 below the iframe that links back to the original.
 */
const VideoEmbed = ({ url, title = 'Guide video', showSource = false }) => {
  const info = parseVideoUrl(url);
  if (!info) return null;

  const providerLabel = info.provider === 'youtube' ? 'YouTube' : 'Vimeo';

  return (
    <div className="my-6" data-testid="guide-video-wrapper">
      <div
        className="rounded-xl overflow-hidden shadow-md bg-black"
        style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}
        data-testid="guide-video-embed"
        data-provider={info.provider}
      >
        <iframe
          title={title}
          src={info.embedUrl}
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
        />
      </div>
      {showSource && url && (
        <p className="text-xs text-gray-500 mt-2 text-right" data-testid="guide-video-source">
          Video fra{' '}
          <a href={url} target="_blank" rel="noopener noreferrer" className="text-cyan-700 hover:underline">
            {providerLabel}
          </a>
        </p>
      )}
    </div>
  );
};

export default VideoEmbed;
